import React from "react";
import { Link } from "react-router-dom";

import BotaoTema from "./BotaoTema";
import PilulaStatus from "./PilulaStatus";
import { SimboloPharu } from "./icones";

/** Marca + status do servidor + tema. */
export default function Topo({ marca, status, escuro }) {
  return (
    <header className="e-top">
      <Link className="brand" to="/login" aria-label={marca.rotuloInicio}>
        <span className="e-mark">
          <SimboloPharu />
        </span>
        <span className="brand-name">
          {marca.nomeCurto}
          {marca.nomeProduto && (
            <>
              {" "}
              <b>{marca.nomeProduto}</b>
            </>
          )}
        </span>
      </Link>
      <div className="top-r">
        <PilulaStatus status={status} />
        <BotaoTema escuro={escuro} />
      </div>
    </header>
  );
}
